<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <router-link class="link-a" :to="'/Expense/Mileage'">
                        Mileage</router-link
                    >
                    /
                    <router-link
                        class="link-a"
                        :to="'/Expense/Mileage/Tl/' + type_status"
                        v-if="chk_permission == 'TL'"
                    >
                        Detail</router-link
                    >
                    <router-link
                        class="link-a"
                        :to="
                            '/Expense/Mileage/' + form_query + '/' + type_status
                        "
                        v-else
                    >
                        Detail</router-link
                    >
                    / Approve
                </h1>
            </v-col>
            <!--  -->
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right"> </v-col>
            <!-- <v-col cols="6" class="text-right"></v-col> -->
        </v-row>

        <!-- {{ role_name }}///{{ chk_approve }}/// {{ edit_map }} -->

        <v-card>
            <v-card class="mx-auto" color="blue lighten-4" dark>
                <v-progress-linear
                    v-if="data_main.length == 0"
                    color="orange accent-4"
                    indeterminate
                ></v-progress-linear>
                <v-card-text v-if="data_main.engineer">
                    <v-row class="mar-t-13">
                        <v-col cols="12" sm="6"
                            ><v-btn
                                text
                                style="font-size:16px;font-weight: bold; color:#FFF; background-color:#3e6d87;"
                                >{{ data_en.engineer_name }}</v-btn
                            ></v-col
                        >
                        <v-col
                            cols="12"
                            :sm="func_chk_approve(chk_approve) === true ? 3 : 6"
                            class="text-right"
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                color="white"
                                class="mr-5 primary--text"
                                v-if="data_log.length > 0"
                                rounded
                                @click="dialogLog = true"
                            >
                                <v-icon left small>mdi-magnify</v-icon>
                                View Approve Log
                            </v-btn>

                            <v-dialog v-model="dialogLog" width="500">
                                <v-card>
                                    <v-card-title
                                        class="subtitle-1 primary--text"
                                    >
                                        APPROVE LOG
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row
                                            v-for="(log, idx) in data_log"
                                            :key="idx"
                                        >
                                            <v-col cols="6">
                                                <b
                                                    >{{ log.log_date }}
                                                    -
                                                    {{ log.log_name }}
                                                </b>
                                            </v-col>
                                            <v-col cols="6">
                                                {{ log.log_note }}
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="dialogLog = false"
                                        >
                                            Close
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="3" class="text-right">
                            <!-- v-on="on" -->
                            <div v-if="func_chk_approve(chk_approve) === true">
                                <v-progress-linear
                                    v-if="chk_approve_2 == true"
                                    color="orange accent-4"
                                    indeterminate
                                ></v-progress-linear>
                                <v-btn
                                    v-if="chk_approve_2 == false"
                                    class="mr-1"
                                    small
                                    color="success"
                                    dark
                                    @click="save_approve('approve')"
                                >
                                    Approve
                                </v-btn>

                                <v-menu
                                    v-if="chk_approve_2 == false"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-width="200"
                                    offset-x
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            color="red"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            Not Approve
                                        </v-btn>
                                    </template>

                                    <v-card>
                                        <v-list>
                                            <v-list-item>
                                                <v-text-field
                                                    small
                                                    label="เหตุผลที่ไม่อนุมัติ..."
                                                    v-model="form_save.remark"
                                                ></v-text-field>
                                            </v-list-item>
                                        </v-list>

                                        <v-card-actions>
                                            <v-btn
                                                small
                                                text
                                                @click="close_approve()"
                                                >Cancel</v-btn
                                            >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                small
                                                color="success"
                                                :disabled="
                                                    form_save.remark.length <= 0
                                                "
                                                @click="
                                                    save_approve('not approve')
                                                "
                                                >Save</v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row class="">
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Total Expense</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.currency }}</span
                            ></v-col
                        >

                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Total KM</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.km }}</span
                            ></v-col
                        >

                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Dist./case</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.distance }}</span
                            >
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Cost/case</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.cost }}</span
                            >
                        </v-col>

                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Vol w/o return</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.vol_job_wo_return }}</span
                            >
                        </v-col>
                        <!-- new -->
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Vol. Job Onsite</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.job_onsite }}</span
                            >
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Vol. Job BenchO</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.job_benchO }}</span
                            >
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Vol. Job Bench</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.job_bench }}</span
                            >
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa">Vol. Return</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.job_return }}</span
                            >
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                            ><span class="fix-das-aa"
                                >Vol. Return - Pickup</span
                            >
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.job_return_pickup }}</span
                            >
                        </v-col>
                        <!-- End new -->
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                        >
                            <span class="fix-das-aa">Cannot contact cust.</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.cannot_contact_count }}</span
                            >
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            class="fix-border-expense-b"
                        >
                            <span class="fix-das-aa">Reschedule</span>
                            <span
                                class="fix-das-aa"
                                style="font-weight: bold; float:right;"
                                >{{ data_paycode.reschedule_count }}</span
                            >
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="data_paycode.province.length > 0"
                        class="fix-p mt-2"
                    >
                        <v-col cols="12" style="margin-top:-5px;">
                            <span class="fix-das-bb">
                                volume job onsite by provinces
                            </span>
                        </v-col>
                        <v-col
                            cols="6"
                            md="4"
                            lg="3"
                            style="margin-top:-5px;"
                            class="fix-border-expense-b mb-1"
                            v-for="(row_province,
                            index_province) in data_paycode.province"
                            :key="index_province"
                        >
                            <span class="fix-das-aa">
                                <b>{{
                                    index_province +
                                        1 +
                                        ". " +
                                        row_province.province_name
                                }}</b>
                            </span>
                            <span
                                class="fix-das-aa "
                                style="font-weight: bold; float:right;"
                                >{{ row_province.volume_job }}</span
                            >
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <div v-for="(row, index) in data_main.detail" :key="index">
                <v-chip
                    small
                    :class="index > 0 ? 'ml-1 mar-t-20' : 'ml-1 mt-8'"
                    color="primary"
                >
                    {{ row.onsite_date + " - " + row.onsite_date_dw }}
                </v-chip>
                <v-chip
                    small
                    :class="index > 0 ? 'ml-1 mar-t-20' : 'ml-1 mt-8'"
                    color="amber"
                    @click="get_MapAllDay(row)"
                >
                    <v-icon small color="green accent-4">
                        mdi-google-maps
                    </v-icon>
                    <span class="ml-2 mr-2">Map all Daily</span>
                    <b class="indigo--text">{{ row.sum_date_km + " KM." }}</b>
                </v-chip>
                <v-row :class="index > 0 ? 'mar-t-18' : 'mar-t-10'">
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center" width="4%">
                                            #
                                        </th>
                                        <th class="text-center" width="37%">
                                            Site
                                        </th>
                                        <th class="text-center" width="37%">
                                            Case Title
                                        </th>
                                        <th class="text-center" width="10%">
                                            GPS / Document
                                        </th>
                                        <th class="text-center" width="4%">
                                            KM
                                        </th>
                                        <th class="text-center" width="4%">
                                            Currency
                                        </th>
                                        <th class="text-center" width="4%">
                                            POI
                                        </th>
                                        <th class="text-center" width="4%">
                                            Route
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(r, i) in row.mileage" :key="i">
                                        <td class="text-center">
                                            {{ i + 1 }}.
                                        </td>
                                        <td>
                                            <v-btn
                                                :disabled="
                                                    r.case_id ==
                                                        'return-pickup' ||
                                                        r.case_id == 'return'
                                                "
                                                class="mt-1 mb-1 mr-1"
                                                :to="
                                                    '/Project/ViewCasepending/' +
                                                        team_name +
                                                        '/' +
                                                        r.maincase_id +
                                                        '/ViewDetail'
                                                "
                                                target="_blank"
                                                small
                                                color="white"
                                                rounded
                                                v-if="r.case_type"
                                            >
                                                <span
                                                    :class="
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                        r.case_id != 'return'
                                                            ? 'primary--text mr-1'
                                                            : 'green--text mr-1'
                                                    "
                                                    >{{
                                                        r.case_id +
                                                            "-" +
                                                            r.subcase
                                                    }}
                                                </span>

                                                <span
                                                    class="teal--text"
                                                    v-if="
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                            r.case_id !=
                                                                'return'
                                                    "
                                                >
                                                    {{ r.created_date }}</span
                                                >
                                            </v-btn>

                                            <v-chip
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                small
                                                :color="
                                                    r.case_type == 'bench'
                                                        ? 'red lighten-1'
                                                        : ''
                                                "
                                                class="mt-1 mb-1 mr-1"
                                                >{{ r.case_type }}</v-chip
                                            >

                                            <v-chip
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                small
                                                class="mt-1 mb-1 mr-1"
                                                >{{ r.project_name }}</v-chip
                                            >
                                            <v-chip
                                                class="mt-1 mb-1"
                                                small
                                                :color="r.colors"
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                >{{ r.site_name }}</v-chip
                                            >

                                            <br />
                                            <span
                                                v-if="
                                                    r.site_amphur_id &&
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                class="mr-1"
                                                ><b>{{
                                                    r.site_amphur_id
                                                }}</b></span
                                            >
                                            <span
                                                v-if="
                                                    r.site_province_id &&
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                ><b>{{
                                                    r.site_province_id
                                                }}</b></span
                                            >

                                            <div
                                                v-if="
                                                    r.site_address &&
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                            >
                                                <span
                                                    small
                                                    style="color:#2E7D32"
                                                    class="font-fix-11"
                                                >
                                                    <v-icon
                                                        small
                                                        class="mr-1"
                                                        color="green darken-3"
                                                    >
                                                        mdi-home </v-icon
                                                    >{{ r.site_address }}</span
                                                >
                                            </div>

                                            <div
                                                v-if="
                                                    r.address &&
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                            >
                                                <span
                                                    class="mt-1 font-fix-11"
                                                    small
                                                    style="color:#F57F17"
                                                    ><v-icon
                                                        small
                                                        class="mr-1"
                                                        color="yellow darken-4"
                                                    >
                                                        mdi-google-maps </v-icon
                                                    >{{ r.address }}</span
                                                >
                                            </div>
                                            <v-chip
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                small
                                                :color="
                                                    func_percentage_color(
                                                        r.percentage
                                                    )
                                                "
                                            >
                                                {{ r.percentage + "%" }}</v-chip
                                            >
                                        </td>
                                        <td>
                                            <span class="font-fix-13">{{
                                                r.case_title
                                            }}</span>
                                            <br />
                                            <b
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                class="font-fix-13"
                                                >{{
                                                    r.sub_status_name +
                                                        " - " +
                                                        r.solution
                                                }}</b
                                            >
                                            <v-chip
                                                small
                                                class="ml-1 mb-1"
                                                v-if="
                                                    r.ship_date != null &&
                                                        r.case_id !=
                                                            'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                >{{
                                                    "Ship : " +
                                                        r.ship_date +
                                                        " - " +
                                                        r.ship_date_dw
                                                }}
                                            </v-chip>
                                            <div
                                                v-if="
                                                    r.case_id == 'return-pickup'
                                                "
                                            >
                                                ิ<b>{{ r.solution }}</b>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <v-icon small>
                                                mdi-google-maps
                                            </v-icon>
                                            <span style="font-size:12px;">{{
                                                r.gps_date
                                            }}</span>

                                            <p
                                                v-if="r.start"
                                                style="font-size:11px;"
                                            >
                                                ( {{ r.start }} ~ {{ r.stop }} )
                                            </p>
                                            <v-chip
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                                small
                                                :color="
                                                    r.doc_status === 'Received'
                                                        ? 'green accent-2'
                                                        : 'red lighten-1'
                                                "
                                            >
                                                <span
                                                    class="ml-1"
                                                    v-if="
                                                        r.doc_status ===
                                                            'Received'
                                                    "
                                                >
                                                    {{
                                                        "Doc : " +
                                                            r.doc_date +
                                                            " - " +
                                                            r.tat_doc +
                                                            " Day"
                                                    }}
                                                </span>
                                                <span v-else>
                                                    Doc Not Received
                                                </span> </v-chip
                                            ><br
                                                v-if="
                                                    r.case_id !=
                                                        'return-pickup' &&
                                                        r.case_id != 'return'
                                                "
                                            />
                                            <v-chip
                                                v-if="r.closed_date != null"
                                                small
                                                class="mt-1"
                                                color="green accent-2"
                                            >
                                                {{
                                                    "Close : " +
                                                        r.closed_date +
                                                        " - " +
                                                        r.tat_close +
                                                        " Day"
                                                }}</v-chip
                                            >
                                            <div v-if="r.cso.length > 0">
                                                <view-image
                                                    class="mt-1"
                                                    :title="
                                                        'CSO ( ' +
                                                            r.cso.length +
                                                            ' )'
                                                    "
                                                    :data="r.cso"
                                                />
                                            </div>
                                            <div
                                                v-if="
                                                    r.case_id == 'return-pickup'
                                                "
                                            >
                                                <view-image
                                                    class="mt-1"
                                                    :title="
                                                        'Attach ( ' +
                                                            r.attach.length +
                                                            ' )'
                                                    "
                                                    :data="r.attach"
                                                />
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            {{ r.km }}
                                        </td>
                                        <td class="text-right">
                                            {{ r.currency }}
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                v-if="r.case_id != 'return'"
                                                :color="
                                                    parseFloat(r.lat) == 0
                                                        ? 'red accent-1'
                                                        : 'green accent-2'
                                                "
                                                x-small
                                                fab
                                                @click="
                                                    change_poi(
                                                        r.case_id,
                                                        index,
                                                        i,
                                                        r.subcase_id
                                                    )
                                                "
                                            >
                                                <v-icon>
                                                    mdi-crosshairs-gps
                                                </v-icon>
                                            </v-btn>
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                :color="r.btn_color"
                                                x-small
                                                fab
                                                @click="
                                                    change_gps(
                                                        r.case_id,
                                                        index,
                                                        i,
                                                        r.subcase_id
                                                    )
                                                "
                                            >
                                                <v-icon :color="r.icon_color">
                                                    mdi-google-maps
                                                </v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <!-- Modal -->
        <v-row justify="center">
            <v-dialog
                v-model="dialogGps"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ form.case_id }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items
                            v-if="edit_map === true && num_change > 1"
                        >
                            <v-btn dark text @click="save()">Save</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-row>
                            <v-col
                                class="mar-t-10"
                                cols="7"
                                style="background-color: #e1f5ff;"
                            >
                                <!-- <v-progress-linear
                                    indeterminate
                                    color="cyan"
                                ></v-progress-linear> -->
                                <div id="app">
                                    <gmap-map
                                        v-show="showMap"
                                        ref="map"
                                        id="map"
                                        :zoom="12"
                                        :center="form.mapStart"
                                        style="width: 100%; height: 471px"
                                    >
                                        <DirectionsRenderer
                                            @dragend="getDirection"
                                        />
                                    </gmap-map>
                                </div>
                            </v-col>
                            <v-col class="mar-t-10 div-scoll-1" cols="5">
                                <span v-if="sum_island > 0" class="red--text"
                                    ><br /><b>{{
                                        "**" + text_show_island
                                    }}</b></span
                                >
                                <!-- <v-progress-linear
                                    indeterminate
                                    color="cyan"
                                ></v-progress-linear> -->
                                <div id="right_panel" ref="right_panel"></div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <v-row>
                                    <v-col cols="12" class="text-center">
                                        <v-btn
                                            v-if="
                                                edit_map === true &&
                                                    form.waypoints != '[]' &&
                                                    form.waypoints !== null
                                            "
                                            rounded
                                            small
                                            color="amber darken-1"
                                            @click="refresh(form.case_id, num)"
                                            ><v-icon>mdi-refresh</v-icon>
                                            Refresh</v-btn
                                        >
                                        <v-btn
                                            v-if="edit_map === true"
                                            rounded
                                            small
                                            class="ml-4"
                                            color="teal accent-2"
                                            @click="same_place(form.subcase_id)"
                                            ><v-icon>mdi-google-maps</v-icon>
                                            สถานที่เดียวกัน</v-btn
                                        >
                                    </v-col>
                                    <v-col cols="12" md="6" class="text-center">
                                        <v-textarea
                                            v-if="
                                                edit_map === true &&
                                                    num_change > 1 &&
                                                    form.waypoints_tmp !=
                                                        form.waypoints
                                            "
                                            outlined
                                            label="Reason.. เหตุผลที่เปลี่ยนเส้นทาง"
                                            v-model="form.mileage_remark"
                                            required
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" md="6" align-self="center">
                                        <b class="red--text font-fix-16"
                                            >ถ้า KM = 0 หรือ มีการเปลี่ยนตำแหน่ง
                                            หรือ ปรับเปลี่ยนตำแหน่ง Mark GPS
                                            ใหม่</b
                                        ><br />
                                        <b class="red--text font-fix-16"
                                            >ให้ไปขยับเส้นทาง(Route)
                                            เพื่อให้ระบบคำนวนระยะทางใหม่</b
                                        ><br /><br /><br />
                                        <b class="red--text font-fix-16"
                                            >กดดู VDO ตัวอย่างได้ที่ปุ่ม ?
                                            (ปุ่มอยู่มุมขวาล่าง)</b
                                        >
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="6" v-if="mileage_log.length > 0">
                                <v-row>
                                    <b><p class="ml-2">Log Mileage</p></b>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Detail
                                                        </th>
                                                        <th class="text-center">
                                                            Created
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(r,
                                                        i) in mileage_log"
                                                        :key="i"
                                                    >
                                                        <td class="text-center">
                                                            {{ i + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            <span
                                                                style="font-size:13px;"
                                                                >{{
                                                                    r.detail
                                                                }}</span
                                                            >
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                small
                                                                color="amber"
                                                                class="mt-1 mb-1"
                                                                >{{
                                                                    r.log_name
                                                                }}</v-chip
                                                            >
                                                            <br />
                                                            <v-chip
                                                                small
                                                                class="mb-1"
                                                                >{{
                                                                    r.log_date
                                                                }}</v-chip
                                                            >
                                                        </td>
                                                    </tr>
                                                    <br />
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-list>
                    <!-- <v-divider></v-divider> -->
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialogMapAllDay"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogMapAllDay = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-toolbar-title>Map all Daily</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <TravelMapAllDay :data_map_all_day="data_map_all_day" />
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogLogGuide" class="mx-auto" max-width="375">
                <v-card>
                    <img
                        src="../../assets/all/guide_gps.png"
                        alt="guide marker"
                        width="100%"
                    />
                </v-card>
            </v-dialog>
        </v-row>

        <v-row>
            <v-col cols="12" class="text-right">
                <v-btn
                    fab
                    fixed
                    align-self-end
                    bottom
                    small
                    style="z-index:100; margin-bottom: 80px; margin-left: -54px;"
                    @click="dialogLogGuide = true"
                >
                    <v-icon color="primary">mdi-help-circle-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialogPoi"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="closePoi()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-toolbar-title>{{
                            data_poi.case_id
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text style="background-color: #b2d5db;">
                        <PoiMap
                            :data_poi="data_poi"
                            @close_page_poi="ClosePoi()"
                        />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import DirectionsRenderer from "../../test/components/DirectionsRenderer"
import TravelMapAllDay from "../Onsite/components/TravelMap"
import Image from "../../components/ViewImage2"
import PoiMap from "../Onsite/components/PoiMap"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        DirectionsRenderer,
        TravelMapAllDay,
        "view-image": Image,
        PoiMap,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        this.emp_id = this.$route.params.emp_id
    },
    mounted() {
        // โหลดข้อมูลหลักกับ log พร้อมกัน (เดิมรอข้อมูลหลักเสร็จก่อนค่อยโหลด log)
        this.get_data()
        this.get_log()
        if (
            this.role_name == "Management" ||
            this.team_name == "HR" ||
            this.emp_img == "P06-297"
        ) {
            this.chk_permission = "BOSS"
        } else {
            this.chk_permission = "TL"
        }

        if (this.team_name != "ONSITE" && this.team_name != "SVC") {
            this.avoid_Highways = true
        } else {
            this.avoid_Highways = false
        }
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            // console.log(this.form_query_paycode)
            await axios
                .get(
                    url +
                        "mileage-approve/view/" +
                        this.emp_id +
                        "/" +
                        this.form_query_paycode,
                    this.tk
                )
                .then((response) => {
                    this.data_main = response.data
                    this.data_en = response.data.engineer
                    this.data_paycode = response.data.paycode
                    //chk_approve เอาไว้ดักเงื่อนไขเรื่อง save/approve
                    this.chk_approve =
                        response.data.paycode.approve_status.requested_status
                    this.text_show =
                        response.data.paycode.approve_status.text_show
                })
                .catch((error) => {
                    // this.mutateIsLoading()
                    console.log(error)
                })
        },
        async get_log() {
            await axios
                .post(
                    url + "mileage/approve-log",
                    {
                        expense_paycode: this.form_query_paycode,
                        expense_by: this.emp_id,
                    },
                    this.tk
                )
                .then((response) => {
                    this.data_log = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        // chk_approve_color(st) {
        //     if (st === null) {
        //         return "blue-grey darken-2"
        //     } else {
        //         if (st === "approve") {
        //             return "green accent-3"
        //         } else {
        //             ;("red accent-2")
        //         }
        //     }
        // },
        formatToPrice(v) {
            return `${v.toFixed()}`
        },
        formatKm(value) {
            let val = (value / 1).toFixed(2).replace(".", ".")
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        async change_gps(case_id, n, ii, subcase_id) {
            this.chk_edit_map(this.chk_approve)
            this.mutateIsLoading()
            this.num = n
            this.form.case_id = case_id
            this.form.subcase_id = subcase_id
            this.form.mapStart.lat = parseFloat(
                this.data_main.detail[n].mileage[ii].lat_start
            )
            this.form.mapStart.lng = parseFloat(
                this.data_main.detail[n].mileage[ii].lng_start
            )
            this.form.mapEnd.lat = parseFloat(
                this.data_main.detail[n].mileage[ii].lat
            )
            this.form.mapEnd.lng = parseFloat(
                this.data_main.detail[n].mileage[ii].lng
            )
            this.form.waypoints = this.data_main.detail[n].mileage[ii].waypoints
            this.form.waypoints_tmp =
                this.form.waypoints == null ? "" : this.form.waypoints

            this.dialogGps = true

            await axios
                .get(url + "mileage-log/" + subcase_id, this.tk)
                .then((response) => {
                    this.mileage_log = response.data
                })
                .catch((error) => {
                    console.log(error)
                })

            setTimeout(() => {
                this.mutateIsLoading()
                if (this.a_directionsService === "") {
                    this.getDirection()
                } else {
                    this.calculateAndDisplayRoute(
                        this.a_directionsService,
                        this.a_directionsDisplay,
                        this.form.mapStart,
                        this.form.mapEnd,
                        this.data_mode
                    )
                }
            }, 3000)
        },
        refresh() {
            this.form.mileage_remark = ""
            this.num_change += 1
            this.form.waypoints = ""
            this.calculateAndDisplayRoute(
                this.a_directionsService,
                this.a_directionsDisplay,
                this.form.mapStart,
                this.form.mapEnd,
                this.data_mode
            )
        },
        getDirection() {
            let directionsService
            let directionsDisplay
            // let draggablesx

            directionsService = new google.maps.DirectionsService()
            directionsDisplay = new google.maps.DirectionsRenderer({
                draggable: this.edit_map,
                scrollwheel: false,
                panel: this.$refs.right_panel,
            })

            directionsDisplay.setMap(this.$refs.map.$mapObject)

            directionsDisplay.addListener("directions_changed", () => {
                let island = this.get_ferries(
                    directionsDisplay.directions.routes[0]
                )
                if (island > 0) {
                    this.sum_island = island
                    this.text_show_island =
                        "หักเส้นทางที่เดินทางโดยเรือ " + island + " KM."
                }
                // console.log(island, "-island")
                this.num_change += 1
                if (this.num_change > 1) {
                    let dataxx = {
                        start: {
                            lat: "",
                            lng: "",
                        },
                        end: {
                            lat: "",
                            lng: "",
                        },
                    }
                    let w = []
                    let rleg = directionsDisplay.directions.routes[0].legs[0]
                    dataxx.start = {
                        lat: rleg.start_location.lat(),
                        lng: rleg.start_location.lng(),
                    }
                    dataxx.end = {
                        lat: rleg.end_location.lat(),
                        lng: rleg.end_location.lng(),
                    }
                    let wp = rleg.via_waypoints
                    for (let i = 0; i < wp.length; i++)
                        w[i] = [wp[i].lat(), wp[i].lng()]
                    dataxx.waypoints = w

                    let str = JSON.stringify(dataxx.waypoints)
                    this.form.waypoints = str
                }
                this.get_ferries(directionsDisplay.directions.routes[0])

                this.computeTotalDistance(directionsDisplay.getDirections())
                // this.get_ferries(directionShow.directions.routes[0])
            })

            this.a_directionsService = directionsService
            this.a_directionsDisplay = directionsDisplay

            this.calculateAndDisplayRoute(
                directionsService,
                directionsDisplay,
                this.form.mapStart,
                this.form.mapEnd,
                this.data_mode
            )
        },
        computeTotalDistance(result) {
            let total = 0
            let time = 0
            let myroute = result.routes[0]
            total += myroute.legs[0].distance.text
            time += myroute.legs[0].duration.text
            // console.log(total, "--x")
            this.form.travel_time = time
            // this.form.km = total

            let res = total.split(" ")
            let total_cal = parseFloat(res[0]) - this.sum_island
            // console.log(total)
            // console.log(parseInt(res[0]) - this.sum_island)
            // console.log(total_cal, "-total_cal")
            this.form.km = total_cal + " " + res[1]
            // console.log(this.form.km)
        },
        calculateAndDisplayRoute(
            directionsService,
            directionsDisplay,
            mapStart,
            mapEnd,
            data_mode
        ) {
            if (this.form.waypoints != null && this.form.waypoints != "") {
                let wayp = JSON.parse(this.form.waypoints)
                let waypts = []
                for (let i = 0; i < wayp.length; i++) {
                    waypts.push({
                        location: {
                            lat: wayp[i][0],
                            lng: wayp[i][1],
                        },
                        stopover: false,
                    })
                }

                directionsService.route(
                    {
                        origin: mapStart,
                        destination: mapEnd,
                        travelMode: data_mode,
                        waypoints: waypts,
                        avoidHighways: this.avoid_Highways,
                    },
                    function(response, status) {
                        if (status === "OK") {
                            directionsDisplay.setOptions({
                                preserveViewport: true,
                            })
                            directionsDisplay.setDirections(response)
                        } else {
                            this.$swal(
                                "เคสก่อนหน้าไม่มีพิกัด / ไม่สามารถจับพิกัดปัจจุบันได้ สามารถกด Save ก่อนและเข้าไปแก้พิกัดย้อนหลังได้ที่หน้า Mileage อีกครั้ง",
                                {
                                    icon: "warning",
                                    button: false,
                                    timer: 2000,
                                }
                            )
                        }
                    }
                )
            } else {
                directionsService.route(
                    {
                        origin: mapStart,
                        destination: mapEnd,
                        travelMode: data_mode,
                        // waypoints: waypts,
                        avoidHighways: this.avoid_Highways,
                    },
                    function(response, status) {
                        if (status === "OK") {
                            directionsDisplay.setOptions({
                                preserveViewport: true,
                            })
                            directionsDisplay.setDirections(response)
                        } else {
                            this.$swal(
                                "เคสก่อนหน้าไม่มีพิกัด / ไม่สามารถจับพิกัดปัจจุบันได้ สามารถกด Save ก่อนและเข้าไปแก้พิกัดย้อนหลังได้ที่หน้า Mileage อีกครั้ง",
                                {
                                    icon: "warning",
                                    button: false,
                                    timer: 2000,
                                }
                            )
                        }
                    }
                )
            }
        },
        close() {
            this.form.mileage_remark = ""
            this.num_change = 0
            this.dialogGps = false
        },
        async save() {
            if (this.num_change > 1 && this.form.mileage_remark === "") {
                this.$swal("กรุณาระบุเหตุผลที่เปลี่ยนเส้นทาง !", {
                    icon: "warning",
                    button: false,
                    timer: 2000,
                })
            } else {
                let data_save = {
                    waypoints: this.form.waypoints,
                    travel_time: this.form.travel_time,
                    km: this.form.km,
                    mileage_remark: this.form.mileage_remark,
                }

                // this.mutateIsLoading()
                await axios
                    .post(
                        url + "mileage/save-waypoint/" + this.form.subcase_id,
                        data_save,
                        this.tk
                    )
                    .then((response) => {
                        this.get_data()
                        // this.mutateIsLoading()
                        this.close()
                        this.mutatesnackbar()
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },

        save_approve(status) {
            this.form_save.status = status
            let textx
            if (status === "approve") {
                textx = "Approve expense"
            } else {
                textx = "Not Approve expense"
            }

            this.$swal({
                title: "Are you sure ?",
                text: textx,
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    // console.log(this.form_save)
                    this.chk_approve_2 = true

                    axios
                        .post(
                            url +
                                "mileage-approve/update-status/" +
                                this.emp_id,
                            this.form_save,
                            this.tk
                        )
                        .then((response) => {
                            // console.log(response)
                            this.menu = false
                            this.form_save.remark = ""
                            this.chk_approve = response.data.requested_status
                            this.data_paycode.approve_status =
                                response.data.requested_status
                            this.chk_approve_2 = false
                            this.mutatesnackbar()
                            this.get_log()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        close_approve() {
            this.menu = false
            this.form_save.remark = ""
        },
        func_chk_approve(st) {
            if (this.role_name === "TL") {
                if (st === "request") {
                    return true
                } else {
                    return false
                }
            } else if (this.role_name === "Manager") {
                if (st === "head approve") {
                    return true
                } else {
                    return false
                }
            } else if (this.role_name === "Management") {
                if (st === "mgr approve") {
                    return true
                } else {
                    return false
                }
            }
        },
        chk_edit_map(status) {
            //ที่แยก function ออกมาเพราะว่าต้องการเรียกค่าใหม่ต่อนคลิกปุ่ม
            if (this.role_name === "TL") {
                if (status === "request") {
                    this.edit_map = true
                } else {
                    this.edit_map = false
                }
            } else if (this.role_name === "Manager") {
                if (status === "head approve") {
                    this.edit_map = true
                } else {
                    this.edit_map = false
                }
            } else if (this.role_name === "Management") {
                if (status === "mgr approve") {
                    this.edit_map = true
                } else {
                    this.edit_map = false
                }
            }
        },
        same_place(subcase_id) {
            // console.log(subcase_id)
            this.$swal({
                title: "Are you sure ?",
                text: "ใช้พิกัดสถานที่ ที่เดียวกันใช้หรือไม่",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .post(
                            url + "mileage/same-place/" + subcase_id,
                            {},
                            this.tk
                        )
                        .then((response) => {
                            this.close()
                            this.get_data()
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        get_MapAllDay(data) {
            this.data_map_all_day = data.mileage
            this.dialogMapAllDay = true
            // console.log(this.data_map_all_day)
        },
        get_ferries(route) {
            let f = [],
                section,
                total
            for (let leg = 0; leg < route.legs.length; ++leg) {
                for (
                    let step = 0;
                    step < route.legs[leg].steps.length;
                    ++step
                ) {
                    section = route.legs[leg].steps[step]
                    if (
                        section.maneuver === "ferry" ||
                        (section.transit &&
                            section.transit.line &&
                            section.transit.line.vehicle &&
                            section.transit.line.vehicle.type === "FERRY")
                    ) {
                        f.push(section)
                        //alert(route.legs[leg].steps[step].distance.value/ 1000.);
                        total =
                            route.legs[leg].steps[step].distance.value / 1000
                    }
                }
            }
            return total
        },
        change_poi(case_id, n, ii, subcase_id) {
            if (parseFloat(this.data_main.detail[n].mileage[ii].lat) == 0) {
                this.center = {
                    lat: 13.7265946,
                    lng: 100.5425997,
                }
                this.markers[0].position = {
                    lat: null,
                    lng: null,
                }
            } else {
                this.center = {
                    lat: parseFloat(this.data_main.detail[n].mileage[ii].lat),
                    lng: parseFloat(this.data_main.detail[n].mileage[ii].lng),
                }
                this.markers[0].position = {
                    lat: parseFloat(this.data_main.detail[n].mileage[ii].lat),
                    lng: parseFloat(this.data_main.detail[n].mileage[ii].lng),
                }
            }

            this.data_poi = {
                case_id: case_id,
                center: this.center,
                markers: this.markers[0].position,
                subcase_id: subcase_id,
                draggable: false,
            }
            this.dialogPoi = true
        },
        closePoi() {
            this.data_poi = {
                center: null,
                markers: null,
            }
            ;(this.markers = [
                {
                    position: { lat: null, lng: null },
                },
            ]),
                (this.dialogPoi = false)
        },
        func_percentage_color(p) {
            if (p <= 29) {
                return "red accent-2"
            } else if (p > 70) {
                return "green accent-2"
            } else {
                return "amber lighten-2"
            }
        },
    },
    data() {
        return {
            chk_approve_2: false,
            data_poi: {
                center: null,
                markers: null,
            },
            markers: [
                {
                    position: { lat: null, lng: null },
                },
            ],
            dialogPoi: false,
            sum_island: 0,
            text_show_island: "",
            dialogLogGuide: false,
            dialogLog: false,
            data_log: [],
            dialogMapAllDay: false,
            data_map_all_day: [],
            chk_align: 0,
            data_main: [],
            data_en: [],
            data_paycode: [],
            duration_time: 2500,
            dialogGps: false,
            modal: false,
            chk_approve: null,
            text_show: "",
            num: 0,
            num_change: 0,
            form: {
                waypoints_tmp: "",
                waypoints: "",
                case_id: 0,
                subcase_id: 0,
                travel_time: "",
                mileage_remark: "",
                km: "",
                mapStart: {
                    lat: "",
                    lng: "",
                },
                mapEnd: {
                    lat: "",
                    lng: "",
                },
            },
            form_search: {
                date: "",
                paycode: "",
                paycode_data: {},
            },
            expense_period: [],
            showMap: true,
            data_mode: localStorage.travel_mode,
            avoid_Highways: true,
            a_directionsService: "",
            a_directionsDisplay: "",
            text: "Success, Your work has been saved",
            tk: "",
            total_job: {
                volume_job: 0,
                sum_km: 0,
                sum_currency: 0,
            },
            emp_id: "",
            menu: false,
            form_save: {
                status: "",
                remark: "",
                paycode: this.$route.query.p,
            },
            role_name: localStorage.role_name,
            team_name: localStorage.team_name,
            emp_img: localStorage.emp_img,
            edit_map: false,
            mileage_log: [],
            chk_permission: "",
            form_query: this.$route.query.q,
            form_query_paycode: this.$route.query.p,
            type_status: this.$route.params.type_status,
        }
    },
}
</script>
<style scoped>
.fix-color-1 {
    color: #597db3;
}
.div-scoll-1 {
    overflow: auto;
    width: 100%;
    height: 500px;
    background-color: #c2eafd;
}

.fix-das-aa {
    color: rgb(52, 68, 109) !important;
    font-size: 14px;
    /* font-weight: bold; */
}
.mar-t-13 {
    margin-top: -13px !important;
}
.fix-h-province {
    background-color: #a2b4d33b;
    border-radius: 4px;
    margin-left: 10px;
    margin-bottom: 3px;
    margin-top: 10px;
    font-weight: bold;
    color: #3f4157;
}
.fix-border-expense-b {
    margin-top: -5px;
    /* border-left: 1px solid #85d1d4; */
    border-right: 2px solid #85d1d4;
}

.fix-das-bb {
    color: rgb(52, 68, 109) !important;
    font-size: 17px;
    font-weight: bold;
}
.fix-p {
    background-color: #fff !important;
    border-radius: 10px;
}
.btn-detail:hover {
    color: #fffb00 !important;
    background-color: #0c374e !important;
}
</style>
